import { render, staticRenderFns } from "./labelSelect.vue?vue&type=template&id=2b2b2eec&scoped=true&"
import script from "./labelSelect.vue?vue&type=script&lang=js&"
export * from "./labelSelect.vue?vue&type=script&lang=js&"
import style0 from "./labelSelect.vue?vue&type=style&index=0&id=2b2b2eec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b2eec",
  null
  
)

export default component.exports